<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">

                    <!--
                    <div>
                        类型：
                        <el-radio-group v-model="searchVal.allotType" @change="initDevAllotOrders">
                            <el-radio-button label="ALL">全部</el-radio-button>
                            <el-radio-button label="0">出库</el-radio-button>
                            <el-radio-button label="1">入库</el-radio-button>
                        </el-radio-group>
                    </div>
                    -->
                    <div style="margin-left: 15px;"> <!-- fill="#EBB563"  -->
                        状态：
                        <el-radio-group v-model="searchVal.allotStatus" @change="initDevAllotOrders">
                            <el-radio-button label="ALL">全部</el-radio-button>
                            <el-radio-button label="1">途中</el-radio-button>
                            <el-radio-button label="2">签收</el-radio-button>
                            <el-radio-button label="3">拒收</el-radio-button>
                        </el-radio-group>
                    </div>
                    <!--
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                    -->
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>

            <!--
            <div v-show="showFV" class="yx-flex-h-start" style="margin-top: 15px;">

                <div>
                    检索：
                    <el-input placeholder="查询内容" v-model="searchVal.keyword"  size="mini" clearable class="input-with-select" style="width: 350px;margin-right: 15px;">
                        <el-select v-model="searchVal.keywordMethod"  size="mini" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                            <el-option
                                    v-for="item in keywordList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-input>
                </div>
                <div>
                    型号：
                    <el-select v-model="searchVal.devModelId" placeholder="设备型号" size="mini" clearable filterable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in devModels"
                                :key="item.id"
                                :label="item.model"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            -->

            <!--<div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-truck" @click="viewAdd">调拨出库</el-button>
                <el-badge :value="12" style="margin-left: 15px;" type="primary" :max="10">
                <el-dropdown trigger="click" @command="changeAllotStatus">
                    <el-button type="danger" icon="el-icon-truck" @click="" :disabled="disableBtn">
                        接收-待确认 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown" style="width: 100px">
                        <el-dropdown-item v-for="(item,index) in allotStatusList" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                </el-badge>
            </div>-->


        </div>


        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table :cell-style="columnbackgroundStyle"
                    :data="devAllotOrders"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="expand" label="">
                    <template slot-scope="props">
                        <div style="padding: 30px 0 30px 50px; width: 500px;">
                            <el-descriptions class="margin-top" title="" :column="1" size="mini" border>
                                <template slot="extra">
                                </template>
                                <el-descriptions-item label="调拨单号">{{ props.row.allotBatNo }}</el-descriptions-item>
                                <el-descriptions-item label="调出方">{{ props.row.outAgentName }}</el-descriptions-item>
                                <el-descriptions-item label="调出方ID">{{ props.row.outAgentId }}</el-descriptions-item>
                                <el-descriptions-item label="调出处理人员">{{ props.row.outAgentPerson }}</el-descriptions-item>
                                <el-descriptions-item label="接收方">{{ props.row.inAgentName }}</el-descriptions-item>
                                <el-descriptions-item label="接收方ID">{{ props.row.inAgentId }}</el-descriptions-item>
                                <el-descriptions-item label="确认处理人员">{{ props.row.inAgentPerson }}</el-descriptions-item>
                                <el-descriptions-item label="快递公司">{{ props.row.expressComp }}</el-descriptions-item>
                                <el-descriptions-item label="快递单号">{{ props.row.expressNo }}</el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" align="center" />
                <el-table-column prop="allotBatNo" label="调拨单号" width="140" align="center" />
                <el-table-column prop="outAgentName" label="调出方" width="110" show-overflow-tooltip />
                <el-table-column prop="inAgentName" label="接收方" width="110" show-overflow-tooltip />
                <el-table-column prop="orderAmount"
                                 label="订单金额" width="100" align="right">
                    <template slot-scope="scope">
                        {{Number(scope.row.orderAmount).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="70" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="dark" :type="scope.row.status===1?'danger':scope.row.status===2?'success':'waring'">
                            {{_enums.DevAllotStatusEnum.getNameById(scope.row.status)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="费用标志" width="80" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderPayFlag===1">-</span>
                        <el-tag v-else effect="dark"
                                :type="scope.row.orderPayFlag===2?'danger':scope.row.orderPayFlag===3?'success':scope.row.orderPayFlag===4?'info':'warning'">
                            {{_enums.DevAllotPayFlagEnum.getNameById(scope.row.orderPayFlag)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-if="this.$store.state.currentHr.agentLevel===0" prop="orderAmount" label="订单金额" width="80" align="right">
                    <template slot-scope="scope">
                        {{scope.row.orderPayFlag===1?'-':scope.row.orderAmount}}
                    </template>
                </el-table-column>
                <el-table-column v-if="this.$store.state.currentHr.agentLevel===0" prop="payAmount" label="实付金额" width="80" align="right">
                    <template slot-scope="scope">
                        {{scope.row.orderPayFlag===1?'-':scope.row.payAmount}}
                    </template>
                </el-table-column>
                <el-table-column prop="devAllotTotals" label="设备数量" width="150">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.devAllotTotals">
                            {{item.model}} <u style="color: blue;font-weight: bolder">{{item.cnt}}</u> 台
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="outDateTime" label="出库时间" width="140" sortable />
                <el-table-column prop="inDateTime" label="入库时间" width="140" sortable />
                <!--
                <el-table-column prop="outAgentPerson" label="出库人员" width="110" show-overflow-tooltip />
                <el-table-column prop="inAgentPerson" label="入库人员" width="110" show-overflow-tooltip />
                <el-table-column prop="expressComp" label="快递公司" width="80"  show-overflow-tooltip/>
                <el-table-column prop="expressNo" label="快递单号" width="80"  show-overflow-tooltip/>
                -->
                <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center" >
                            <el-button type="text" style="padding: 5px" size="mini"  @click="viewDetail(scope.row)">详情</el-button>
                            <el-button type="text" style="padding: 5px" size="mini" v-if="scope.row.orderPayFlag===2 && scope.row.status===_enums.DevAllotStatusEnum.途中.id" @click="confirmFreeOrder(scope.row.allotBatNo)">免单</el-button>
                            <el-button type="text" style="padding: 5px;visibility:hidden;" size="mini" v-else >免单</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            -->
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            <div class="yx-flex-v">
                <!--
                <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                -->
                <el-tag type="info" style="margin-left: 0px;">
                    <i class="header-icon el-icon-info"></i>
                    入库调拨待确认：&nbsp;&nbsp;{{totalTxt}}
                </el-tag>
            </div>
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="slot, sizes, prev, pager, next, jumper, total"
                    :pager-count="5"
                    :total="total">
                <!--
                <span>共计{{total}}台&nbsp;&nbsp;</span>
                -->
            </el-pagination>
        </div>

        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                class="dlg-normal">
            <div style="height: 350px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="devInfoForm" :rules="rules" ref="devInfoForm">
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="调拨单号" prop="purBatNo">
                                    <el-input size="small" v-model="devInfoForm.purBatNo" :disabled="true" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="接收单位" prop="purBatNo222">
                                    <el-input size="small" value="主仓库" :disabled="true" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="设备SN" prop="purBatNo222">
                                    <el-input type="textarea" :rows="10" size="small" v-model="devInfoForm.terSNsList"  placeholder="终端SN，换行，“-”批量录入号段，例如001-005"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                      <el-tooltip content="增加序号|号段" placement="top">
                        <el-button type="danger" plain icon="el-icon-plus" @click.prevent="addDevInfoInput"></el-button>
                       </el-tooltip>
                        <el-tag type="info" style="margin-left: 10px">
                            <i class="header-icon el-icon-info"></i>
                            预入库：&nbsp;&nbsp;
                            型号：{{devMod}}&nbsp;&nbsp;
                            数量：{{devCnt}}&nbsp;&nbsp;
                        </el-tag>
                    </div>
                    <div>
                        <el-button size="small" @click="showDlg = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommit">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>



        <el-drawer
                class="drw"
                :with-header=false
                :visible.sync="drawer"
                :show-close=false
                size = "50%"
                direction="rtl">
            <DevAllotDetailDiv :key="devAllotOrder.allotBatNo" v-bind:inDevAllotOrder="devAllotOrder" v-bind:outDrawerClose.sync="drawerRe"></DevAllotDetailDiv>
        </el-drawer>

    </div>

</template>

<script>

    import {
        URL_DATA_ALLOTORDERNO
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import DevAllotDetailDiv from "../../components/dev/DevAllotDetailDiv";

export default {
        name: "DevAllotArch",
    components: {DevAllotDetailDiv, AreaSelect},
    data() {
            return {
                drawer: false,
                drawerRe: false,
                disableBtn: true,
                allotStatusList:[{'id':2,'name':'接收入库'},{'id':3,'name':'拒收'}],
                title: '',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showFV: false,
                dialogVisible: false,
                loading: false,
                total: 0,
                totalTxt:'',
                page: 1,
                size: 10,
                titleDlg: '',
                showDlg: false,
                devAllotOrders: [],
                devAllotOrder:{},
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    allotType: 'ALL',
                    allotStatus: 'ALL',
                    outDateScope: null,
                    inDateScope: null,
                    devModelId: null,
                    devStrStatId: null,
                    devActStatId: null
                },
                keywordList: [
                    {id:"terSn",name:"终端SN"}
                ],
                devMod: '',
                devCnt: 0,
                devInfoForm: {
                    modelId: null,
                    terSNsList:[],
                    terSNs: [{value:'',key:Date.now()}],
                    purBatNo:null,
                    purDateTime:null,
                    devStrStat:1,
                    devActStat:1,
                    inAgentId:1,
                    inAgentName:null,
                    inDateTime:null,
                    devModel:{},
                    inAgent:{}
                },
                insDevInfoList: [],
                insDevInfo: {
                    modelId:null,
                    terSn:null,
                    purBatNo:null,
                    devStrStat:null,
                    devActStat:null
                },
                rules: {
                    purBatNo: [{required: true, message: '请输入purBatNo', trigger: 'blur'}],
                    purBatNo222: [{required: true, message: '请输入purBatNo222', trigger: 'blur'}],
                    modelId: [{required: true, message: '请输入modelId', trigger: 'blur'}],
                }
            }
        },
        watch:{
            drawer: {
                handler:function(val) {
                    if(this.drawer===true) {
                        this.drawerRe = true;
                    }
                }
            },
            drawerRe: {
                handler:function(val) {
                    if(this.drawerRe===false) {
                        this.initDevAllotOrders();
                    }
                }
            },
            devInfoForm: {
                handler:function(val) {
                    if(this.devInfoForm.terSNs.length>0) {
                        let sns = this.devInfoForm.terSNs;
                        this.devCnt = 0;
                        this.devMod = '';
                        for(let i=0;i<this.devModels.length;i++) {
                            if(this.devInfoForm.modelId==this.devModels[i].id) {
                                this.devMod = this.devModels[i].model;
                                break;
                            }
                        }
                        for(let i=0;i<sns.length;i++) {
                            if(sns[i].value) {
                                if(sns[i].value.indexOf("-")!=-1) {
                                    let sn_sn = sns[i].value.split("-");
                                    if(sn_sn.length==2 && sn_sn[0].length==sn_sn[1].length) {
                                        let len = sn_sn[0].length;
                                        let sn1 = sn_sn[0];
                                        let sn2 = sn_sn[1];
                                        let idx = -1;
                                        for(let j=len-1;j>=0;j--) {
                                            if( sn1.charCodeAt(j)>=48 && sn1.charCodeAt(j)<=57
                                                && sn2.charCodeAt(j)>=48 && sn2.charCodeAt(j)<=57 ) {
                                                idx = j;
                                            }
                                            else break;
                                        }
                                        if(idx>=0) {
                                            sn1 = sn1.substring(idx);
                                            sn2 = sn2.substring(idx);
                                            let snc = sn2-sn1;
                                            if(snc==0) this.devCnt++;
                                            else if(snc>0) this.devCnt += sn2-sn1+1;
                                        }
                                    }
                                }
                                else {
                                    this.devCnt++;
                                }
                            }
                        }
                    }
                },
                deep:true
            }
        },
        mounted() {
            this.initDevAllotOrders();
        },
        computed: {
        },
        methods: {
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            confirmFreeOrder(allotBatNo) {
                this.allotBatNo = allotBatNo
                this.$confirm('确定免单？调拨单号：' + allotBatNo, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.putRequest("/dev/devAllotPayFlagChange" + "?allotBatNo=" + allotBatNo + "&reqFlag=4").then(resp => {
                        if (resp && resp.status===200) {
                            this.initDevAllotOrders()
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            viewDetail(data) {
                Object.assign(this.devAllotOrder, data);
                this.drawer = true;
            },
            addDevInfoInput() {
                let key = Date.now();
                this.devInfoForm.terSNs.push({
                    value: '',
                    key: key
                });
                //console.log(key)
                //this.$refs['p'+key][0].focus();
            },
            removeDevInfoInput(item) {
                let index = this.devInfoForm.terSNs.indexOf(item);
                if (index !== 0) {
                    this.devInfoForm.terSNs.splice(index, 1);
                }
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initDevAllotOrders();
            },
            initDevAllotOrders() {
                this.loading = true;
                let urlParam = '?page=' + this.page + '&size=' + this.size;
                if (this.searchVal.allotType && this.searchVal.allotType!="ALL") {
                    urlParam += '&type=' + this.searchVal.allotType;
                }
                if (this.searchVal.allotStatus && this.searchVal.allotStatus!="ALL") {
                    urlParam += '&status=' + this.searchVal.allotStatus;
                }


                /**
                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                 */

                this.getRequest("/dev/devAllotOrderAll" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devAllotOrders = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initDevAllotOrders();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initDevAllotOrders();
            },
            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            exportData() {
                let urlParam = '/dev/devAllotOrderAll/export?page=1';
                if (this.searchVal.allotType && this.searchVal.allotType!="ALL") {
                    urlParam += '&type=' + this.searchVal.allotType;
                }
                if (this.searchVal.allotStatus && this.searchVal.allotStatus!="ALL") {
                    urlParam += '&status=' + this.searchVal.allotStatus;
                }

                window.open(urlParam, '_parent');
            },
            showAddEmpView() {
            },
            viewAdd() {
                this.titleDlg = '调拨出库';
                this.insDevInfoList = [];
                this.devInfoForm.modelId = null;
                this.devInfoForm.terSNs = [{value:'',key:Date.now()}];
                this.getPurBatNo();
                this.showDlg = true;
            },
            getPurBatNo() {
                this.getRequest(URL_DATA_ALLOTORDERNO).then(resp => { if (resp) this.devInfoForm.purBatNo = resp.obj.no });
            },
            dlgCommit() {
                this.insertDevInfo();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            changeAllotStatus(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                /*
                this.putRequest("/agent/updateAgentStat" + "?statusId=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initAgents();
                    }
                });*/
            },
            insertDevInfo() {
                let cnt = this.devInfoForm.terSNs.length;
                if(cnt<=0) return;

                for(let i=0;i<cnt;i++) {
                    let snTemp = this.devInfoForm.terSNs[i].value;
                    if(snTemp.indexOf("-")!=-1) {
                        let sn_sn = snTemp.split("-");
                        if(sn_sn.length==2 && sn_sn[0].length==sn_sn[1].length) {
                            let len = sn_sn[0].length;
                            let sn1 = sn_sn[0];
                            let sn2 = sn_sn[1];
                            let idx = -1;
                            for(let j=len-1;j>=0;j--) {
                                if( sn1.charCodeAt(j)>=48 && sn1.charCodeAt(j)<=57
                                    && sn2.charCodeAt(j)>=48 && sn2.charCodeAt(j)<=57 ) {
                                    idx = j;
                                }
                                else break;
                            }
                            if(idx>=0) {
                                let sn1Header = sn1.substring(0,idx);
                                let sn2Header = sn2.substring(0,idx);
                                if(sn1Header==sn2Header) {
                                    sn1 = sn1.substring(idx);
                                    sn2 = sn2.substring(idx);
                                    let snc = sn2-sn1;
                                    for(let k=0;k<=snc;k++) {
                                        let sn = Number.parseInt(sn1)+k;
                                        this.insDevInfo = {};
                                        this.insDevInfo.modelId = this.devInfoForm.modelId;
                                        this.insDevInfo.purBatNo = this.devInfoForm.purBatNo;
                                        this.insDevInfo.devStrStat = this.devInfoForm.devStrStat;
                                        this.insDevInfo.devActStat = this.devInfoForm.devActStat;
                                        this.insDevInfo.terSn = sn1Header+sn;
                                        this.insDevInfoList.push(this.insDevInfo);
                                    }
                                }
                                else {
                                    // 前段不同
                                }
                            }
                        }
                    }
                    else {
                        this.insDevInfo = {};
                        this.insDevInfo.modelId = this.devInfoForm.modelId;
                        this.insDevInfo.purBatNo = this.devInfoForm.purBatNo;
                        this.insDevInfo.devStrStat = this.devInfoForm.devStrStat;
                        this.insDevInfo.devActStat = this.devInfoForm.devActStat;
                        this.insDevInfo.terSn = this.devInfoForm.terSNs[i].value;
                        this.insDevInfoList.push(this.insDevInfo);
                    }
                }

//                console.log(JSON.stringify(this.insDevInfoList));
//                return;

                this.postRequest("/dev/addDevInfo", this.insDevInfoList).then(resp => {
                    if (resp) {
                        this.initDevAllotOrders();
                        this.showDlg = false;
                    }
                })
            }
        }

    }
</script>

<style scoped>
</style>
